/*
 * @Author: gaobin
 * @Date: 2024-10-09 15:47:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-08 19:04:15
 * @Description: getters
 */
const getters = {
  token: (state) => state.user.token,
  utmSource: (state) => state.globalInfo.utm_source,
  lang: (state) => state.user.lang,
  userInfo: (state) => state.user.userInfo,
  getPermissionAuth: (state) => state.permission.permissionAuth,
  returnAddressId: (state) => state.address.returnAddressId,
};

export default getters;
